"use strict";

const LayerPort = {
  add: function (app) {
    const insertScriptTag = () => {
      const layerScript = document.createElement("script");
      const layerStyles = document.createElement("link");

      layerScript.src = "/layer-web-components/dist/layer-web-components.js";
      layerScript.type = "module";
      layerStyles.href = "/layer-web-components/dist/layer-web-components.css";
      layerStyles.rel = "stylesheet";

      document.head.appendChild(layerScript);
      document.head.appendChild(layerStyles);
    };

    app.ports.layerPortLoad.subscribe(() => {
      if (window.layerLoaded) return;

      insertScriptTag();

      window.layerLoaded = true;
    });
  },
};

module.exports = LayerPort;
